#import "../fragments/account-last-contacted-time-fragment.graphql"

query GetAccountLastContactedTime($id: ID!) {
    account(id: $id) {
        ...AccountLastContactedTimeFragment
    }
}
